const playlistIDs = [
    // "37i9dQZF1DWWY64wDtewQt",
    // "5PCv6afEatU3z9cq2fBPDs",
    // "3KI0KPVq1pORf8EYpNajEa",
    // "5hZXWkdIZEtOgt8tpllIKL",
    // "13wPxTXqgmzxjxowAaq9OJ",
    // "5RTPHsbPFXRkUoPJcvvcvI",
    // "37i9dQZF1E35YF5o0RQQLJ",
    // "37i9dQZF1DWXe9gFZP0gtP",
    // "37i9dQZF1DWZUTt0fNaCPB",
    // "37i9dQZF1DXa2PsvJSPnPf",
    // "37i9dQZF1DWTtTyjgd08yp",
    // "37i9dQZF1DWTG97QsiX8kA",
    // "37i9dQZF1DX0XUsuxWHRQd",
    // "37i9dQZF1DWTyiBJ6yEqeu",
    // "37i9dQZF1DX0BcQWzuB7ZO",
    // "37i9dQZF1DX1tyCD9QhIWF",
    // "37i9dQZF1DX4eRPd9frC1m",
    // "37i9dQZF1DX1X23Q8KMK6z",
    // "37i9dQZF1DX70RN3TfWWJh",
    // "37i9dQZF1DWSXBu5naYCM9",
    // "37i9dQZF1DWZtZ8vUCzche",
    // "37i9dQZF1DX4SBhb3fqCJd",
    // "37i9dQZF1DX10zKzsJ2jva",
    // "37i9dQZF1DX4VvfRBFClxm",
    // "37i9dQZF1DX7a4JC3PRmJH",
    // "37i9dQZF1DX7gIoKXt0gmx",
    // "37i9dQZF1DWYs83FtTMQFw",
    // "37i9dQZF1DX2sUQwD7tbmL",
    // "37i9dQZF1DX0MLFaUdXnjA",
    // "37i9dQZF1DWTJ7xPn4vNaz",
    // "37i9dQZF1DX4X63r2LRvz8",
    // "37i9dQZF1DX5LSzJh0xNg8",
    // "37i9dQZF1DX2A29LI7xHn1",
    // "37i9dQZF1DWYkaDif7Ztbp",
    // "37i9dQZF1DWUFmyho2wkQU",
    // "37i9dQZF1DWU5d8llV5Jga",
    // "37i9dQZF1DWT6SJaitNDax",
    // "37i9dQZF1DWT7XSlwvR1ar",
    // "37i9dQZF1DXcWBRiUaG3o5",
    // "37i9dQZF1DX8S9gwdiXEL1",
    // "37i9dQZF1DWTJlZz3LRjlZ",
    // "37i9dQZF1DWVYfpN6pCEQX",
    // "37i9dQZF1DX10zKzsJ2jva",
    // "37i9dQZF1DX4VvfRBFClxm",
    // "37i9dQZF1DX7a4JC3PRmJH",
    // "37i9dQZF1DX7gIoKXt0gmx",
    // "37i9dQZF1DWYs83FtTMQFw",
    // "37i9dQZF1DX2sUQwD7tbmL",
    // "37i9dQZF1DX0MLFaUdXnjA",
    // "37i9dQZF1DX9oh43oAzkyx",
    // "37i9dQZF1DWZeKCadgRdKQ",
    // "37i9dQZF1DX2A29LI7xHn1",
    // "37i9dQZF1DX7a4JC3PRmJH",
    // "37i9dQZF1DXaQtr8lgugVm",
    // "37i9dQZF1DXdCgjm8u3gGJ",
    // "37i9dQZF1DWY1XXiglmJaP",
    // "37i9dQZF1DX0Tkc6ltcBfU",
    // "37i9dQZF1DX6z20IXmBjWI",
    // "37i9dQZF1DX5P58TzYDiZb",
    // "37i9dQZF1DX6GiJlVeD6Ou",
    // "37i9dQZF1DX5uokaTN4FTR",
    // "37i9dQZF1DX5CdVP4rz81C",
    // "37i9dQZF1DX08jcQJXDnEQ",
    // "37i9dQZF1DX3Z9crdrKLbZ",
    // "37i9dQZF1DX3rxVfibe1L0",
    // "37i9dQZF1DX0bUGQdzC7Kg",
    // "37i9dQZF1DWVqfgj8NZEp1",
    // "37i9dQZF1DX68H8ZujdnN7",
    // "37i9dQZF1DX4o1oenSJRJd",
    // "37i9dQZF1DX7HTfSf8Gx6P",
    // "37i9dQZF1DXW9ub4fC0g3A",
    // "37i9dQZF1DX4bCxHYwM3Fz",
    // "37i9dQZF1DX2sUQwD7tbmL",
    // "37i9dQZF1DWYs83FtTMQFw",
    // "37i9dQZF1DX0MLFaUdXnjA",
    // "37i9dQZF1DX9oh43oAzkyx",
    // "37i9dQZF1DWZeKCadgRdKQ",
    // "37i9dQZF1DX2A29LI7xHn1",
    // "37i9dQZF1DX7a4JC3PRmJH",
    // "37i9dQZF1DXaQtr8lgugVm",
    // "37i9dQZF1DXdCgjm8u3gGJ",
    // "37i9dQZF1DWY1XXiglmJaP",
    // "37i9dQZF1DX0Tkc6ltcBfU",
    // "37i9dQZF1DX6z20IXmBjWI",
    // "37i9dQZF1DX5P58TzYDiZb",
    // "37i9dQZF1DX6GiJlVeD6Ou",
    // "37i9dQZF1DX5uokaTN4FTR",
];


const topPlaylists = [
    "37i9dQZF1DXcrFZ8UTtxv9",
    "1nvb2n40sho2nivz3QXxGh",
    "2zgVGclUkFkaIRktiYuLbx",
    "50t3qXkHCwFyKTI091sy18",
    "73pL7GHExZgUOzqAm1TaRE",
    "6o7gNzBS28KNDmwzAxwJkw",
    "6AgEwibUPC5JZaY9ETk7B6",
    "6s58rM1lE2siSYgBNueZse",
    "27RBVtXi53GKoesWF7bYv0",
    "1Y9PH7gPFxJgwB9DqFBxwL",
    "3zCIdLCGKOFa3XWq1yo5SF",
]

export default playlistIDs;
export {topPlaylists}

// console.log(playlistIDs.length); // Output: 100
